module.exports = __webpack_public_path__ + "static/img/sanxingAL1.9ffc56f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/sanxingAL1.jpg
// module id = vvs0
// module chunks = 0